import ajax from '@/utils/ajax'

export default {
  /*获取验证码*/
  getVerifyCode (param) {
    return ajax.post('/getVerifyCode', param)
  },
  /*被邀请用户注册*/
  userRegister (param) {
    return ajax.post('/register', param)
  },
  /*资讯详情*/
  findInformationDetail (param) {
    return ajax.post('/findInformationDetail', param)
  },
  /*活动详情*/
  findActivityDetail (param) {
    return ajax.post('/findActivityDetail', param)
  },
  /*报名*/
  saveSignUp (param) {
    return ajax.post('/saveSignUp', param)
  },
  /*动态*/
  getTrendsDetail (param) {
    return ajax.post('/getTrendsDetail', param)
  },
  /*下载统计*/
  addDownloadHis (param) {
    return ajax.post('/addDownloadHis', param)
  },
  /*获取下载地址*/
  getDownLoadUrl (param) {
    return ajax.post('/getDownLoadUrl', param)
  },
  /*活动资格*/
  findSenior (param) {
    return ajax.post('/findSenior', param)
  },
  /*抽奖活动报名*/
  signUp (param) {
    return ajax.post('/signUp', param)
  },
  /*抽奖结果*/
  findResult (param) {
  return ajax.post('/findResult', param)
  },
  /*中奖人员展示*/
  findWinning (param) {
    return ajax.post('/findWinning', param)
  },
  /*留资信息*/
  saveUserInfo (param) {
    return ajax.post('/saveUserInfo', param)
  },

  /*转盘奖品信息*/
  findPrizes (param) {
    return ajax.post('/findPrizes', param)
  },
  /*转盘抽奖*/
  drawPrizeByChannel (param) {
    return ajax.post('/drawPrizeByChannel', param, { ignoreLoading: true })
  },
  /*获取消息详情*/
  messageDetail (param) {
    return ajax.post('/messageDetail', param)
  },
  /*盲订留资获取验证码*/
  reservationGetVerifyCode(param) {
    return ajax.post('/getReservationVerifyCode', param)
  },
  /*盲订留资添加预约信息*/
  reservationAddInfomation(param) {
    return ajax.post('/saveInformation', param)
  },
  
  findOrderByOrderId(param) {
    return ajax.post('/findOrderByOrderId', param)
  },

  addShareReservation(param) {
    return ajax.post('/addShareReservation', param)
  },

  findVehicleModelDeploy(param) {
    return ajax.post('/findVehicleModelDeploy', param)
  },

  QAList(param) {
    return ajax.post('/QA/list', param)
  },

  reportYear(param){
    return ajax.post('/report/year', param)
  },

  wechatShare(param){
    return ajax.post('/wechat/jsapi/signature', param)
  },
  /* 深度试驾 getVerifyCode */
  getSignUpDeepDrivers(param){
    return ajax.post('/getSignUpDeepDrivers', param, { ignoreLoading: true })
  },
  signDeepDrive(param){
    return ajax.post('/deepDriverSignUp', param, { ignoreLoading: true })
  },
  inviteRegisterByMobile(param){
    return ajax.post('/inviteRegisterByMobile', param, { ignoreLoading: true })
  },
  deepDriveGetVerifyCode(param) {
    return ajax.post('/deepDriveGetVerifyCode', param, { ignoreLoading: true })
  },
  findDealerByCityCode(param) {
    return ajax.post('/findDealerByCityCode', param, { ignoreLoading: true })
  },
  findInformations(param) {
    return ajax.post('/findInformations', param, { ignoreLoading: true })
  },
  findSpecialTopicDetail(param) {
    return ajax.post('/findSpecialTopicDetail', param, { ignoreLoading: true })
  },
  save(param) {
    return ajax.post('/save', param, { ignoreLoading: false })
  },
  getByCondition(param) {
    return ajax.post('/getByCondition', param, { ignoreLoading: true })
  },
  getServiceCities(param) {
    return ajax.post('/getServiceCities', param, { ignoreLoading: true })
  },
  becomeGoldFoxCard(param) {
    return ajax.post('/becomeGoldFoxCard', param,)
  },
  findVehicleOwnerRights(param) {
    return ajax.post('/findVehicleOwnerRights', param,)
  },
  findFinancialPolicy(param) {
    return ajax.post('/findFinancialPolicy', param,)
  },
  getVehicleCarousel(param) {
    return ajax.post('/getVehicleCarousel', param,)
  },
  getLongImg(param) {
    return ajax.post('/getLongImg', param,)
  },
  getCCBDecrypt(param) {
    return ajax.post('/getCCBDecrypt', param,)
  },
  getHXCreditSign(param) {
    return ajax.post('/getHXCreditSign', param,)
  },
  getHXCreditUserInfo(param) {
    return ajax.post('/getHXCreditUserInfo', param,)
  },
  getHXDecrypt(param) {
    return ajax.post('/getHXDecrypt', param,)
  },
}

